export default __webpack_public_path__ + "static/media/ErrorIllustration.72bafb18.svg";